import * as React from 'react';
import Select from 'react-select';

import { humanize } from '../gs-core/common';

import { DocStatus, DocStatuses } from '../common/models';

interface DocStatusSelectProps {
  selectedStatuses?: DocStatus[];
  onChange: (statuses?: DocStatus[]) => void;
}

interface OptionType {
  value: string;
  label: string;
}

const styles = {
  control: (base: any, { isFocused }: { isFocused: boolean }) => {
    if (isFocused) {
      return {
        ...base,
        minHeight: 28,
        '&:hover': { borderColor: '#66afe9' },
        borderColor: '#66afe9',
        boxShadow: 'inset 0 1px 1px rgba(0,0,0,.075), 0 0 8px rgba(102, 175, 233, 0.6);'
      };
    }

    return { ...base, minHeight: 28, borderColor: '#767676' };
  },
  input: (base: any) => ({ ...base, margin: 0 }),
  dropdownIndicator: (base: any) => ({ ...base, padding: '0 4px' }),
  clearIndicator: (base: any) => ({ ...base, padding: '0 4px' }),
  multiValueLabel: (base: any) => ({ ...base, padding: '1px 3px' }),
  placeholder: (base: any) => ({ ...base, color: '#767676' }),
};

export const DocStatusSelect = ({ selectedStatuses = [], onChange }: DocStatusSelectProps) => {
  const options = DocStatuses.filterable().map(status => ({ value: status, label: humanize(status) }));

  const values = options.filter(option => selectedStatuses.includes(option.value));

  const change = (selectedOptions: OptionType[]) => {
    const statuses = selectedOptions.map(option => option.value as DocStatus);

    onChange(statuses);
  };

  return (
    <Select
      aria-label="Filter by status"
      name="statuses"
      placeholder="Status"
      styles={styles}
      value={values}
      isMulti={true}
      onChange={change}
      options={options}
    />
  );
};



// WEBPACK FOOTER //
// ./src/DocListView/DocStatusSelect.tsx